export type AppConfirmOptions = {
  title: string;
  body?: string;
  details?: string[];
  confirmLabel?: string;
  cancelLabel?: string;
  tone?: "default" | "danger";
};

export type AppMessageOptions = {
  title: string;
  body?: string;
  tone?: "default" | "danger" | "success";
};

const CONFIRM_EVENT = "app-confirm-request";
const MESSAGE_EVENT = "app-message-request";

type ConfirmDetail = AppConfirmOptions & {
  resolve: (value: boolean) => void;
};

type MessageDetail = AppMessageOptions;

export const confirmAction = (options: AppConfirmOptions) =>
  new Promise<boolean>((resolve) => {
    window.dispatchEvent(new CustomEvent<ConfirmDetail>(CONFIRM_EVENT, { detail: { ...options, resolve } }));
  });

export const showAppMessage = (options: AppMessageOptions) => {
  window.dispatchEvent(new CustomEvent<MessageDetail>(MESSAGE_EVENT, { detail: options }));
};

export const onConfirmRequest = (handler: (detail: ConfirmDetail) => void) => {
  const listener = (event: Event) => handler((event as CustomEvent<ConfirmDetail>).detail);
  window.addEventListener(CONFIRM_EVENT, listener);
  return () => window.removeEventListener(CONFIRM_EVENT, listener);
};

export const onMessageRequest = (handler: (detail: MessageDetail) => void) => {
  const listener = (event: Event) => handler((event as CustomEvent<MessageDetail>).detail);
  window.addEventListener(MESSAGE_EVENT, listener);
  return () => window.removeEventListener(MESSAGE_EVENT, listener);
};
